// The portal's objects on My requests (docs/OBJECTS.md, Portal): which objects this person may see, and their menu rows.
// Kept apart from records.tsx (the records' screens and forms) so the portal's first screen does not load those.
import { useEffect, useState } from 'react';
import { portalObjectsApi, type PortalObject } from '../../api/objects';
import type { PortalMe } from '../../api/portal';
import { navigate } from '../../router';

const at = (o: PortalObject) => `/portal/objects/${encodeURIComponent(o.id)}`;

/** The portal objects this person may see: null while loading; none, quietly, when the server answers no. */
export function usePortalObjects(me: PortalMe) {
  const client = me.clients[0]?.id ?? '';
  const [objects, setObjects] = useState<PortalObject[] | null>(null);
  useEffect(() => {
    let on = true;
    if (!client) setObjects([]);
    else portalObjectsApi.list(client).then((o) => { if (on) setObjects(Array.isArray(o) ? o : []); }, () => { if (on) setObjects([]); });
    return () => { on = false; };
  }, [client]);
  return objects;
}

/** The menu entries on My requests: one row per object shown in the portal. */
export function PortalObjectLinks({ objects }: { objects: PortalObject[] }) {
  if (!objects.length) return null;
  return (
    <nav className="mt-8" aria-label="Records" data-testid="portal-objects">
      <h2 className="section-title mb-3">More</h2>
      <ul className="grid gap-2">
        {objects.map((o) => (
          <li key={o.id}>
            <a href={at(o)} onClick={(e) => { e.preventDefault(); navigate(at(o)); }} className="card flex min-h-[56px] items-center gap-3 px-4 text-[16px] font-semibold hover:bg-panel-2" data-testid={`portal-object-${o.id}`}>
              <span className="min-w-0 flex-1 truncate">{o.plural || o.name}</span><span aria-hidden="true" className="text-faint">›</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

